export const base_path = "/react/template";
export const img_path = "/react/template/";

export const PORT = 8989;
export const apibaseurl = "https://engine.auptech.in";
// export const apibaseurl = "http://192.168.1.7:8001";

// ======== auth api ============

export const loginApi = "/api/v1/candidate/login";
export const verifyLoginOTPApi = "/api/v1/candidate/verify-login-otp";
export const forgotPassword = "/api/v1/candidate/forgot-password";
export const verifyForgotOtp = "/api/v1/candidate/verify-forgot-otp";
export const ResetNewPassword = "/api/v1/candidate/set-new-password";
export const firstLogin = "/api/v1/candidate/first-login";
export const verifyfirstLoginOTP = "/api/v1/candidate/verify-otp";
export const changeFirstLoginPass = "/api/v1/candidate/change-password";
export const getProfile = "/api/v1/candidate/me";
export const getAllPackage = "/api/v1/candidate/sidebar-packages";
export const getPersonalDetails = "/api/v1/candidate/personal_details";
export const updatePersonalDetails = "/api/v1/candidate/personal_details";
export const getDashboard = "/api/v1/candidate/dashboard";
export const allUniversities = "/api/v1/candidate/universities";
// export const allColleges = "/api/v1/candidate/colleges/{{university_value}}";
export const allCountries = "/api/v1/candidate/countries";

export const REACT_APP_SUREPASS_API_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJmcmVzaCI6ZmFsc2UsImlhdCI6MTc3OTg2NTIyMSwianRpIjoiMjBhNmY2ZWItZTgyYS00YjIwLTgyMDAtNzc2MDEyZGViZmM5IiwidHlwZSI6ImFjY2VzcyIsImlkZW50aXR5IjoiZGV2LnVzZXJuYW1lXzJ2cWZ3eWprZ2txcmVoZWhmd2FqejBsbGZyMUBzdXJlcGFzcy5pbyIsIm5iZiI6MTc3OTg2NTIyMSwiZXhwIjoxNzgyNDU3MjIxLCJlbWFpbCI6InVzZXJuYW1lXzJ2cWZ3eWprZ2txcmVoZWhmd2FqejBsbGZyMUBzdXJlcGFzcy5pbyIsInRlbmFudF9pZCI6Im1haW4iLCJ1c2VyX2NsYWltcyI6eyJzY29wZXMiOlsidXNlciJdfX0.3x7PGGAPNKP4EJS0nrniyTqIoNJxHonygB3rUcbKQVs";
